/**
 * Text Formatting Utilities
 * 
 * This file provides functions to format column names, tags, and other text
 * to be business-friendly by removing underscores, adding spaces between words,
 * and properly capitalizing text.
 */

/**
 * Formats text to be business-friendly by:
 * 1. Removing underscores and replacing with spaces
 * 2. Adding spaces between camelCase words
 * 3. Adding spaces between letters and numbers
 * 4. Capitalizing the first letter of each word
 * 5. Cleaning up multiple spaces
 * 
 * @param {string} text - The text to format
 * @returns {string} - The formatted text
 */
export const formatBusinessText = (text) => {
  if (!text || typeof text !== 'string') return text;

  // Remove underscores and replace with spaces
  let formatted = text.replace(/_/g, ' ');
  
  // Add spaces between camelCase words (e.g., ClientName -> Client Name)
  formatted = formatted.replace(/([a-z])([A-Z])/g, '$1 $2');
  
  // Add spaces between words that have numbers (e.g., Client1Name -> Client 1 Name)
  formatted = formatted.replace(/([a-zA-Z])(\d)/g, '$1 $2');
  formatted = formatted.replace(/(\d)([a-zA-Z])/g, '$1 $2');
  
  // Capitalize first letter of each word
  formatted = formatted.replace(/\b\w/g, (char) => char.toUpperCase());
  
  // Clean up multiple spaces
  formatted = formatted.replace(/\s+/g, ' ').trim();
  
  return formatted;
};

export default formatBusinessText;
